// extracted by mini-css-extract-plugin
export default {"button":"styles_button__cLVM3","fullWidth":"styles_fullWidth__q+z4N","secondaryButton":"styles_secondaryButton__Vos+w","revButton":"styles_revButton__dVhln"};